<template>
  <router-view />
</template>

<style lang="scss">
@use "@/styles/settings.scss";
</style>

<script lang="ts" setup>
import { useBlarSupportWidget } from '@/composables/useBlarSupportWidget'
import { isConnectorLoginHost } from '@/utils/connectorLoginHost'

if (!isConnectorLoginHost()) useBlarSupportWidget()
</script>
